class Api {
	constructor() {
		this.artist = {
			info: (artist) => this.req({method:'artist.getInfo', artist: artist}),
			albums: (artist) => this.req({method:'artist.getTopAlbums', artist: artist}),
			similar: (artist) => this.req({method:'artist.getSimilar', artist: artist}),
		};
		this.album = {
			info: (artist, album) => this.req({method:'album.getInfo', artist: artist, album: album}),
		},
		this.track = {
			info: (artist, track) => this.req({method:'track.getInfo', artist: artist, track: track}),
			similar: (artist, track) => this.req({method:'track.getSimilar', artist: artist, track: track}),
		}	
	}

	async req(data) {
		let resp = await fetch('https://trackhunter.deflate.ru/api/', {
			method: 'POST',
			headers: {Accept: 'application/json', 'Content-Type': 'application/json'},
			body: JSON.stringify(data)
		});
		return resp.json();
	}
}

export default class TH {
	constructor() {
		this.tree = []; 
		this.api  = new Api();
	}
	newNode = (name, type, data={}) => ({name, type, data})
	fmtMMSS(s){return(s-(s%=60))/60+(9<s?':':':0')+s}
}

// class Node {
// 	constructor(name, type, data={}) {
// 		this.name = name;
// 		this.type = type;
// 		this.data = data;
// 	}
// }


// let a = [
// {
// 	type: 1,
// 	data: {
// 		info: {},
// 		albums: [],
// 		similar: [
// 			{
// 				type: 1,
// 				data: {}
// 			}
// 		]
// 	}
// }
// ]